import { Component } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { OverlayComponent } from '../../components/overlay/overlay.component';
import { OverlayToggleDirective } from '../../components/overlay/overlay-toggle.directive';

@Component({
  selector: 'td-wb-nasdaq-basic-pagenote',
  templateUrl: 'nasdaq-basic-pagenote.component.html',
  styleUrls: ['nasdaq-basic-pagenote.component.scss'],
  imports: [
    TranslateDirective,
    OverlayToggleDirective,
    OverlayComponent
  ]
})
export class NasdaqBasicPagenoteComponent {}
